import selectors from '../../../../rootSelectors';
import { activateReadyForNextScreen } from '../../../../common/questions/questionsActions';
import { blockScreen, greyOutScreen, unblockScreen } from '../../../../common/screen/screenActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../../common/avatar/avatarActions';
import { narrateStart, narrateReset } from '../../../../common/audio/audioActions';
import { goToCountdown } from '../../../../common/navigation/navigationActions';
import { autoplayScript } from '../../vocabFITBActions';
import { VOCAB } from '../../../../constants/measure';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';

export const narratePracticeScreen = stimulusAudio => async (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(narrateStart());
    await dispatch(
        playAvatarAudio([VOCAB_AUDIO_INSTRUCTIONS[language].vocabFITBPracticeInstructionStart]),
    );
    await dispatch(autoplayScript(0, stimulusAudio, PRACTICE));
    dispatch(narrateReset());
    dispatch(unblockScreen());
};

export const onNextPracticeButtonClick = () => (dispatch, getState) => {
    const state = getState();
    const language = selectors.getCurrentLanguage(state);

    dispatch(blockScreen());
    dispatch(greyOutScreen());

    if (!selectors.getQuestionsIsReadyForNextScreen(state)) {
        return dispatch(
            playAvatarAudio([VOCAB_AUDIO_INSTRUCTIONS[language].vocabFITBPracticeReadyInstruction]),
        ).then(() => {
            dispatch(setAvatarInstructions(VOCAB_AUDIO_INSTRUCTIONS[language].clickOk));
            dispatch(activateReadyForNextScreen());
            return dispatch(unblockScreen());
        });
    }

    return dispatch(goToCountdown(VOCAB.ASSESSMENT, VOCAB.FITB));
};
